export const getMediaDisplayUrl = (media) => {
  if (!media) return null;
  return media.displayUrl || media.url || media.src || null;
};

export const isPendingMedia = (media) => Boolean(media?.file) && !media?.id;

export const createPreviewUrl = (file) => {
  if (!file) return null;
  return URL.createObjectURL(file);
};

export const revokePreviewUrl = (mediaOrUrl) => {
  const url = typeof mediaOrUrl === 'string' ? mediaOrUrl : mediaOrUrl?.displayUrl;
  if (url?.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};

export const normalizePhotoFromApi = (photo) => {
  if (!photo) return photo;
  if (photo.displayUrl) return photo;
  return {
    ...photo,
    displayUrl: photo.url,
  };
};

export const normalizeVideoFromApi = (video) => {
  if (!video) return video;
  if (video.displayUrl) {
    return {
      ...video,
      src: video.src || video.displayUrl,
    };
  }
  const displayUrl = video.url || video.src;
  return {
    ...video,
    src: displayUrl,
    displayUrl,
  };
};

export const normalizeProductMedia = (media = {}) => ({
  photos: (media.photos || []).map(normalizePhotoFromApi),
  videos: (media.videos || []).map(normalizeVideoFromApi),
});

export const revokeMediaCollection = (items = []) => {
  items.forEach(revokePreviewUrl);
};
